import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { CommonService } from 'src/app/services/common.service';
import { BadeLoftService } from 'src/app/views/badeloft-pages/bade-loft.service';
import { EntityType, ResponseMessageStatus, ResponseStatus } from '../../enums';

@Component({
  selector: 'app-audit-history',
  templateUrl: './audit-history.component.html',
  styleUrls: ['./audit-history.component.css'],
})
export class AuditHistoryComponent implements OnInit {
  //#region properties
  isVisible = false;
  @Output() hideModal = new EventEmitter();
  @Input() entityType: number;
  @Input() entityDetails: any;
  entityTypes: typeof EntityType;
  lst_AuditLog: any = [];
  //#endregion

  //#region  functions
  getAuditLogList() {
    this._blS
      .GetAuditLog(
        this.entityType == this.entityTypes.Status
          ? this.entityDetails.transactionID
          : this.entityDetails.id,
        this.entityType
      )
      .subscribe((res) => {
        if (res) {
          if (res.responseStatus == ResponseStatus.Success) {
            this.lst_AuditLog = res.result ? res.result : [];
          } else {
            this._cS.displayMessage(ResponseMessageStatus.error, res.message);
          }
        }
      });
  }

  handleCancel(data?: any): void {
    this.isVisible = false;
    this.hideModal.emit({ hide: true, data: data ? data : null });
  }
  //#endregion
  constructor(private _blS: BadeLoftService, private _cS: CommonService) {
    this.entityTypes = EntityType;
  }

  ngOnInit(): void {
  }

  ngAfterViewInit(): void {
    this.isVisible = true;
    this.getAuditLogList();
  }
}
